import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
// eslint-disable-next-line @typescript-eslint/no-require-imports
const { version } = require('../../../../package.json');

const releaseStage = (window.env.CARE_SUBENVIRONMENT || window.env.CARE_ENVIRONMENT)?.toLowerCase();

window.env.CARE_BUGSNAG_API_KEY &&
  Bugsnag.start({
    apiKey: window.env.CARE_BUGSNAG_API_KEY,
    appVersion: version,
    plugins: [new BugsnagPluginReact()],
    releaseStage: releaseStage,
  });
